/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { PaginaDocument } from '@gql/graphql'
import { SostenibilitaDetailTemplate } from '@components/templates'

const SostenibilitaDetailPage = ({ pagina, paginaParent }) => (
  <SostenibilitaDetailTemplate pagina={pagina} paginaParent={paginaParent} />
)

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []

  // for (const locale of locales) {
  //   if (locale === 'default') continue

  //   const client = initializeApollo(locale)

  //   const {
  //     data: { pagina },
  //   } = await client.query({
  //     query: PaginaDocument,
  //     variables: { chiave: 'sostenibilita', withMenuChildren: true },
  //   })

  //   if (pagina?.children && pagina.children.length > 0) {
  //     pagina?.children
  //       ?.filter((x) => x.chiave !== "certificazioni")
  //       .forEach((x) => paths.push({ params: { slug: x.slug }, locale }))
  //   }
  // }

  return {
    paths: paths,
    fallback: 'blocking',
  }
}, '/sostenibilita/[slug]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina: paginaParent },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'sostenibilita', preview, withMenuChildren: true },
      context: {
        headers,
      },
    })

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { path: `${paginaParent.url}/${slug}`, preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: { pagina, paginaParent },
      revalidate: 60 * 20,
    }
  },
  '/sostenibilita/[slug]'
)

export default SostenibilitaDetailPage
